import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Sports = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-sports.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Sports"
                breadEnd="Sports"
                breadMid="Learning Approach"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/swimming.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                <b>Sport and Physical Education</b> is fundamental to the early
                development of children. Introducing the students to an Early
                learning principle of Sports helps them develop physically and
                emotionally.
              </p>

              <p>
                We have 3 standard <b>Badminton</b> courts with quality
                equipments. A world class fully air conditioned synthetic and
                standard indoor Basketball Court with BFI approved equipments is
                a highlight of our School.
              </p>

              <p>
                Our NSI qualified <b>Cricket</b> Coaches work to build the
                skills in our learners through various Inter and Intra class/
                House Matches.
              </p>

              <p>
                <b>True Wealth is having Healthy mind, body and spirit.</b> To
                facilitate the thought, we provide our students an opportunity
                to play <b>CHESS</b> as an essential analysis building activity,
                wherein the learners are groomed by an International Level
                Player and are taken to various competitions to challenge
                themselves in a bigger scenario.
              </p>

              <p>
                Our learner’s favourite sport <b>‘Swimming’,</b> is complimented
                by the ‘One of its kind’{" "}
                <b>Olympic Size all season Indoor pool</b> which spreads over 25
                meters with 6 lanes. Swimming is a part of the curriculum and
                provides the learners ample opportunities to hone their skills.
                Simultaneously, <b>Skating</b> is another activity that plays a
                pivotal role in child’s growth and Development. Our school
                caters to the requirement through a well provided skating space
                and holds extra classes for the learners before and after the
                school working hours. Our learners have won many accolades in
                the same and are extensively trained by our experienced coaches.
              </p>

              <p>
                We are the winner of Decathlon Cup 2016 and a standard size{" "}
                <b>Football field </b> helps the learners to train themselves
                through various matches and aggressive physical training by
                experienced Coaches. A well designed and equipped{" "}
                <b>Lawn Tennis court</b> has a neutral ground that suits many
                different playing styles with both fast and powerful players.
              </p>

              <p>
                To achieve broader goals in Education and Development,{" "}
                <b>Lotus Valley International School Gurgaon </b>organizes
                various sports programmes which focus on the development of each
                individual. The school provides the best ATF approved equipments
                and the learners are trained by NIS (National Institute of
                Sports) qualified Coaches.
              </p>
              <p>
                Through participation in sport and Physical Education, learners
                develop an understanding of the importance of key values such
                as:
              </p>
            </div>
            <div className="col-12">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/key1.png"
                  className="img-fluid m-2 mx-auto d-block"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Sports;
